/* RESPONSIBLE TEAM: team-standalone */

import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { taskFor } from 'ember-concurrency-ts';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';

export default class ErrorLogsIndexRoute extends Route {
  @service declare finStandaloneService: FinStandaloneService;

  async beforeModel() {
    await taskFor(this.finStandaloneService.loadApiErrors).perform();
  }
}
